import { DeepPartial, ESTENSA_MODULE_SECONDARY_APPLICATION_SETTINGS_SERVICE } from '@se/platform';
import { SecondaryApplicationSettings } from 'estensa-module';

export class NullSecondaryApplicationSettingsService {
    getAsJSON(): Promise<DeepPartial<SecondaryApplicationSettings>> {
        return Promise.resolve({
            alertSound: '',
            notificationSound: '',
            fseHelp: {},
        });
    }
}

export function provideMockSecondarySettingsService() {
    return {
        provide: ESTENSA_MODULE_SECONDARY_APPLICATION_SETTINGS_SERVICE,
        useClass: NullSecondaryApplicationSettingsService,
    };
}
